import React from 'react';

const Company = () => {
    return (
        <div className='min-h-[80vh] p-10 text-[#6366F1] container mx-auto'>
            
            <h2 className='text-center hover:text-yellow-500 text-4xl mt-5 font-semibold'>
                Company Name : HMSoftTecH Innovation
            </h2>
            <h2 className='text-center hover:text-blue-500 text-4xl mt-5 font-semibold'>
                Country : USA
            </h2>
            <h2 className='text-center hover:text-green-500 text-4xl mt-5 font-semibold'>
                Position : CEO @ Founder
            </h2>

        </div>
    );
};

export default Company;